



































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";

class PagecouponTransferRequest extends PageRequest {
  isActivity: null;
}

@Component({
  components: {},
})
export default class couponTransfers extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PagecouponTransferRequest = new PagecouponTransferRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  couponTransferId: number = null;
  couponTransferList: Array<any> = [
    {
      value: "true",
      label: "是",
    },
    {
      value: "false",
      label: "否",
    },
  ];
  statusList: Array<any> = [
    {
      value: "true",
      label: "启用",
    },
    {
      value: "false",
      label: "关闭",
    },
  ];

  get list() {
    return this.$store.state.couponTransfer.list;
  }

  get loading() {
    return this.$store.state.couponTransfer.loading;
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("couponTransfer/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("couponTransfer/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("couponTransfer/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "couponTransfer/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.couponTransfer.pageSize;
  }

  get totalCount() {
    return this.$store.state.couponTransfer.totalCount;
  }

  get currentPage() {
    return this.$store.state.couponTransfer.currentPage;
  }
  columns = [
    {
      title: "转赠人",
      render: (h: any, params: any) => {
        return h("span", params.row.fromUser.userName? params.row.fromUser.userName:'暂无');
      },
    },
     {
      title: "转赠人手机号",
      render: (h: any, params: any) => {
        return h("span", params.row.fromUser.phoneNumber? params.row.fromUser.phoneNumber:'暂无');
      },
    },
     {
      title: "被转赠人",
      render: (h: any, params: any) => {
        return h("span", params.row.toUser.userName?params.row.toUser.userName:'暂无');
      },
    },
     {
      title: "被转赠人手机号",
      render: (h: any, params: any) => {
        return h("span", params.row.toUser.phoneNumber?params.row.toUser.phoneNumber:'暂无');
      },
    },
    {
      title: "优惠券金额",
      render: (h: any, params: any) => {
        return h("span", params.row && params.row.coupons.length>0?params.row.coupons[0].amount:'暂无');
      },
    },
     {
      title: "优惠券类型",
      render: (h: any, params: any) => {
        return h("span",  params.row && params.row.coupons.length>0? params.row.coupons[0].couponType==1?'球场券':'新人券' :'暂无');
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.creationTime).toLocaleString());
      },
    },
    // {
    //   title: this.L("Actions"),
    //   key: "Actions",
    //   width: 150,
    //   align: "center",
    //   slot: "action",
    //   render: (h: any, params: any) => {
    //     return h("div", [
    //       h(
    //         "Button",
    //         {
    //           props: {
    //             type: "error",
    //             size: "small",
    //           },
    //           on: {
    //             click: async () => {
    //               this.$Modal.confirm({
    //                 title: this.L("Tips"),
    //                 content: "确定要删除该记录吗",
    //                 okText: this.L("Yes"),
    //                 cancelText: this.L("No"),
    //                 onOk: async () => {
    //                   await this.$store.dispatch({
    //                     type: "couponTransfer/delete",
    //                     data: params.row,
    //                   });
    //                   await this.getpage();
    //                 },
    //               });
    //             },
    //           },
    //         },
    //         "删除"
    //       ),
    //     ]);
    //   },
    // },
  ];
  async created() {
    this.getpage();
  }
}
